import { translate } from '../../libs/translateService';
import flowLinksService from 'src/libs/flowLinksService';

export default ({ hash: { translations, englishTranslation, germanTranslation } }) => {
  return translate(
    translations,
    {
      hash: {
        englishTranslation,
        englishUrl: flowLinksService.getLocalizedFlowLink('en_GB', 'language_selection'),
        germanTranslation,
        germanUrl: flowLinksService.getLocalizedFlowLink('de', 'language_selection')
      }
    });
};
